import Select from "react-select";
import { filterStyles } from "./SelectStyles";
import { TSelectionFilter } from "@/app/types/types";

const SelectionFilter = ({
    name,
    placeholder,
    onChange,
    options,
}: TSelectionFilter) => {
    const fieldName = name || placeholder.toLowerCase().replace(/\s+/g, "-");
    const inputId = `${fieldName}-input`;

    return (
        <div className="w-[100%] lg:w-[15rem] font-['national']">
            <label htmlFor={inputId} className="sr-only">
                {placeholder}
            </label>
            <Select
                inputId={inputId}
                name={fieldName}
                aria-label={placeholder}
                options={options as any}
                onChange={onChange}
                placeholder={placeholder}
                styles={filterStyles}
                isSearchable={false}
            />
        </div>
    );
}

export default SelectionFilter;